/* eslint-disable no-unused-vars */
import { useCallback, useState, useRef } from 'react';
import { ModalHeader, ModalFooter, Loader } from 'components';
import { canvasPreview } from './CanvasPreview';
import * as S from './CroppingImgUI.styled';
import { creativesActions } from 'store/campaign/creatives';
import ReactCrop from 'react-image-crop';
import { useDispatch, useSelector } from 'react-redux';
import { MEDIATYPES } from 'constants';
import { manageCreativeMediaAPI } from 'services/manageCreativeMedia.service';
import 'react-image-crop/dist/ReactCrop.css';

const imgType = {
  image: '0',
  image_landscape: '1',
};

export const CroppingImgUI = ({ handleClose, creativeModalType, selectedFile$ }) => {
  const [onUploadMedia, uploadMediaResult] =
    manageCreativeMediaAPI.useUploadMediaToServerMutation();

  const dispatch = useDispatch();

  const [completedCrop, setCompletedCrop] = useState({
    width: 270,
    height: 270,
  });
  const [crop, setCrop] = useState({
    unit: 'px', // Can be 'px' or '%'
    x: 10,
    y: 100,
    width: 270,
    height: 270,
  });
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);

  const setCropping = (e) => {
    canvasPreview(imgRef.current, previewCanvasRef.current, e, 1);
    setCompletedCrop(e);
    setCrop(e);
  };

  const onImageLoaded = useCallback((image, creativeModalType) => {
    const { width, height } = image.currentTarget;
    if (creativeModalType === 'image') {
      const minValue = Math.min(width, height);
      const cropObj = {
        unit: 'px',
        x: 0,
        y: 0,
        width: minValue,
        height: minValue,
      };
      setCropping(cropObj);
      return;
    }
    if (creativeModalType === 'image_landscape') {
      const aspectRatio = 590 / 309;
      let cropWidth = width;
      let cropHeight = width / aspectRatio;
      if (cropHeight > height) {
        cropHeight = height;
        cropWidth = cropHeight * aspectRatio;
      }
      const cropObj = {
        unit: 'px',
        x: 0,
        y: 0,
        width: cropWidth,
        height: cropHeight,
      };
      setCropping(cropObj);
      return;
    }
  }, []);
  const app_package = useSelector((state) => state.creatives.creativeAndTrackingData.app_package);
  const pba_id = useSelector((state) => state.creatives.creativeAndTrackingData.pba_id);

  const saveCroppedAreaInDB = useCallback(async () => {
    if (!previewCanvasRef.current) {
      return;
    }
    const context = previewCanvasRef.current.getContext('2d');
    context.rect(0, 0, completedCrop.width, completedCrop.height);
    const image = context.getImageData(0, 0, completedCrop.width, completedCrop.height);
    image.name = 'cxxxxxx';
    const reqImageUpload = {
      imageType: imgType[creativeModalType],
      pba_id: pba_id,
      package_id: app_package,
      file: context.canvas.toDataURL('image/png'),
    };
    const res = await onUploadMedia(reqImageUpload);
    if (res?.data?.success) {
      dispatch(creativesActions.setIsUploading(true));
      dispatch(creativesActions.setUploadingIcon(true));
      dispatch(creativesActions.setUploadingImage(true));
      handleClose();
    }
  }, [completedCrop.width, completedCrop.height]);

  return (
    <>
      {uploadMediaResult.isLoading && <Loader.Global />}
      <ModalHeader title='Creatives manager' close={handleClose} />
      <S.Box>
        <ReactCrop
          aspect={creativeModalType !== MEDIATYPES.IMAGE_LANDSCAPE ? 1 : 590 / 309}
          crop={crop}
          onChange={(c) => setCropping(c)}
        >
          <img
            src={selectedFile$.value[0]['data_url']}
            ref={imgRef}
            alt='Crop'
            onLoad={(e) => onImageLoaded(e, creativeModalType)}
          />
        </ReactCrop>
        <canvas
          ref={previewCanvasRef}
          hidden={true}
          style={{
            border: '4px solid #3B89F6',
            objectFit: 'contain',
            width: completedCrop.width,
            height: completedCrop.height,
          }}
        />
      </S.Box>
      <ModalFooter
        saveButtonText='Use Cropped'
        saveButtonOnClick={saveCroppedAreaInDB}
        close={handleClose}
        saveButtonDisabled={uploadMediaResult.isLoading}
      />
    </>
  );
};
